import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Snackbar,
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  //Divider,
  //CircularProgress,
  //IconButton
} from '@mui/material';
import './Appointment.css'; // Reusing the same styles
import { getDatabase, ref, push, set, onValue } from 'firebase/database';
import emailjs from '@emailjs/browser';
import { useVacation } from '../context/VacationContext';
//import AccessTimeIcon from '@mui/icons-material/AccessTime';
//import PersonIcon from '@mui/icons-material/Person';
//import ContentCutIcon from '@mui/icons-material/ContentCut';
import AddIcon from '@mui/icons-material/Add';
//import { useNavigate } from 'react-router-dom';

function WalkIn() {
  const vacationMode = useVacation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    service: '',
    notes: '',
    email: ''
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [setError] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState('Walk-in request submitted successfully!');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [appointments, setAppointments] = useState([]);
  const [walkIns, setWalkIns] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    try {
      const db = getDatabase();
      
      const appointmentsRef = ref(db, 'appointments');
      const appointmentsUnsubscribe = onValue(appointmentsRef, (snapshot) => {
        const data = snapshot.val();
        console.log('Raw appointments data:', data);
        
        const today = new Date().toISOString().split('T')[0];
        console.log('Today\'s date for comparison:', today);
        
        let allAppointments = [];
        
        if (data) {
          allAppointments = Object.entries(data).map(([key, value]) => {
            console.log(`Raw appointment: ${JSON.stringify(value)}`);
            return {
              ...value,
              firebaseKey: key
            };
          });
          
          console.log(`Total appointments in database: ${allAppointments.length}`);
          
          const todaysAppointments = allAppointments.filter(app => {
            console.log(`Comparing: App date "${app.date}" with today "${today}"`);
            return app.date === today;
          });
          
          console.log(`Appointments for today (${today}): ${todaysAppointments.length}`);
          
          todaysAppointments.sort((a, b) => {
            const timeA = a.time ? a.time.toLowerCase() : '';
            const timeB = b.time ? b.time.toLowerCase() : '';
            return timeA.localeCompare(timeB);
          });
          
          if (todaysAppointments.length === 0) {
            console.log('No appointments for today, showing all appointments for debugging');
            setAppointments(allAppointments);
          } else {
            setAppointments(todaysAppointments);
          }
        } else {
          console.log('No appointments data found in Firebase');
          setAppointments([]);
        }
      });

      const walkInsRef = ref(db, 'walkIns');
      const walkInsUnsubscribe = onValue(walkInsRef, (snapshot) => {
        const data = snapshot.val();
        console.log('Walk-ins data:', data);
        
        let walkInsList = [];
        
        if (data) {
          walkInsList = Object.entries(data)
            .map(([key, value]) => ({
              ...value,
              firebaseKey: key
            }))
            .filter(w => w.status !== 'completed')
            .sort((a, b) => {
              const statusOrder = {
                'in-progress': 0,
                'waiting': 1
              };
              return statusOrder[a.status || 'waiting'] - statusOrder[b.status || 'waiting'];
            });
          
          console.log('Filtered walk-ins:', walkInsList.length);
        }
        
        setWalkIns(walkInsList);
      });

      const walkInRequestsRef = ref(db, 'walkins');
      const requestsUnsubscribe = onValue(walkInRequestsRef, (snapshot) => {
        const data = snapshot.val();
        console.log('Walk-in requests data:', data);
        
        let requestsList = [];
        
        if (data) {
          requestsList = Object.entries(data)
            .map(([key, value]) => ({
              ...value,
              firebaseKey: key,
              source: 'request',
              status: value.status || 'waiting'
            }))
            .filter(w => w.status === 'pending');
          
          console.log('Filtered walk-in requests:', requestsList.length);
        }
        
        setWalkIns(prevWalkIns => {
          const existingWalkIns = prevWalkIns.filter(w => w.source !== 'request');
          return [...existingWalkIns, ...requestsList];
        });
      });

      return () => {
        appointmentsUnsubscribe();
        walkInsUnsubscribe();
        requestsUnsubscribe();
      };
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const db = getDatabase();
      const appointmentsRef = ref(db, 'walkins');
      
      const newWalkIn = {
        id: Date.now(),
        ...formData,
        status: 'pending',
        type: 'walk-in',
        createdAt: new Date().toISOString(),
        date: new Date().toISOString().split('T')[0],
        time: new Date().toLocaleTimeString(),
        duringVacation: vacationMode?.active || false
      };

      const newWalkInRef = push(appointmentsRef);
      await set(newWalkInRef, newWalkIn);
      
      try {
        const emailParams = {
          to_email: process.env.REACT_APP_ADMIN_EMAIL,
          from_name: formData.name,
          customer_phone: formData.phone,
          service: formData.service,
          notes: formData.notes || 'No additional notes',
          vacation_notice: vacationMode?.active ? 'This walk-in was requested during your vacation period.' : '',
          admin_url: `${window.location.origin}/admin?u=${btoa('admin')}&p=${btoa('Bingo69@2022')}`
        };

        await emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          emailParams,
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );
      } catch (emailError) {
        console.error('Error sending email notification:', emailError);
      }
      
      setSnackbarMessage('Walk-in request submitted successfully! Please wait for confirmation.');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setFormData({
        name: '',
        phone: '',
        service: '',
        notes: '',
        email: ''
      });
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error saving walk-in request:', error);
      setError(`Error submitting walk-in request: ${error.message}`);
      setSnackbarMessage('Failed to submit walk-in request. Please try again.');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const services = [
    'Haircut $25',
    'Beard Trim $20',
    'Hot Towel Shave $40',
    'Kids Haircut $25',
    'Facial Treatment $40',
    'Complete Package $50',
    'Straight Razor Shave $25',
  ];

  const getStatusChip = (status) => {
    const statusConfig = {
      'in-progress': { color: 'info', label: 'In Progress', bgColor: '#e3f2fd', textColor: '#0d47a1' },
      'waiting': { color: 'warning', label: 'Waiting', bgColor: '#fff8e1', textColor: '#f57f17' },
      'pending': { color: 'warning', label: 'Pending', bgColor: '#fff8e1', textColor: '#f57f17' },
      'confirmed': { color: 'success', label: 'Confirmed', bgColor: '#e8f5e9', textColor: '#1b5e20' },
      'cancelled': { color: 'error', label: 'Cancelled', bgColor: '#ffebee', textColor: '#b71c1c' }
    };

    const config = statusConfig[status] || statusConfig.waiting;
    return (
      <Chip
        label={config.label}
        color={config.color}
        size="small"
        sx={{ 
          whiteSpace: 'nowrap',
          fontWeight: 500,
          backgroundColor: config.bgColor,
          color: config.textColor
        }}
      />
    );
  };

  const calculateEstimatedWait = () => {
    const inProgressCount = walkIns.filter(w => w.status === 'in-progress').length;
    const waitingCount = walkIns.filter(w => w.status === 'waiting' || w.status === 'pending').length;
    const confirmedAppointmentsCount = appointments.filter(app => app.status === 'confirmed').length;
    
    const estimatedMinutes = (inProgressCount * 15) + (waitingCount * 30) + (confirmedAppointmentsCount * 30);
    
    if (estimatedMinutes < 15) {
      return 'Less than 15 minutes';
    } else if (estimatedMinutes < 60) {
      return `About ${estimatedMinutes} minutes`;
    } else {
      const hours = Math.floor(estimatedMinutes / 60);
      const mins = estimatedMinutes % 60;
      return `About ${hours} hour${hours !== 1 ? 's' : ''} ${mins > 0 ? `and ${mins} minutes` : ''}`;
    }
  };

  if (vacationMode?.active) {
    return (
      <Container maxWidth="md" className="appointment-container" sx={{ py: 8 }}>
        <Alert severity="info" sx={{ mb: 3, bgcolor: '#f8f9fa', border: '1px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', borderRadius: 2, p: 2 }}>
          The barber is currently on vacation from {vacationMode.startDate.toLocaleDateString()} to {vacationMode.endDate.toLocaleDateString()}. 
          Walk-in services are not available during this period. Please check back after {vacationMode.endDate.toLocaleDateString()} or 
          book a regular appointment for a date after the vacation period.
        </Alert>
        <Button 
          variant="contained" 
          color="primary" 
          href="/appointment"
          fullWidth
          sx={{ mt: 2 }}
        >
          Book a Regular Appointment
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" className="appointment-container" sx={{ px: { xs: 1, sm: 3 } }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={7}>
          <Paper elevation={3} className="appointment-form" sx={{ 
            p: { xs: 2, md: 3 }, 
            borderRadius: '10px !important',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1) !important',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.95) !important'
          }}>
            <Typography 
              variant="h4" 
              component="h1" 
              gutterBottom 
              align="center" 
              className="form-title"
              sx={{ 
                fontSize: { xs: '1.5rem', md: '2rem' },
                color: 'var(--primary-color) !important',
                fontWeight: '600 !important',
                marginBottom: '1rem !important',
                textAlign: 'center'
              }}
            >
              Current Barber Status
            </Typography>
            
            {/* Barber Status */}
            <Box sx={{ 
              mb: 3, 
              p: { xs: 1.5, md: 2.5 }, 
              borderRadius: 2,
              bgcolor: '#f8f9fa',
              border: '1px solid #e9ecef',
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
            }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    p: 2,
                    borderRadius: 2,
                    bgcolor: '#e3f2fd',
                    height: '100%',
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.1)'
                  }}>
                    <Box sx={{ mr: 2, color: '#1976d2' }}>
                      <AddIcon fontSize="large" />
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 500, color: '#1976d2', fontSize: '0.9rem' }}>
                        Estimated Wait Time
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                        {calculateEstimatedWait()}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    p: 2,
                    borderRadius: 2,
                    bgcolor: '#e8f5e9',
                    height: '100%',
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.1)'
                  }}>
                    <Box sx={{ mr: 2, color: '#2e7d32' }}>
                      <AddIcon fontSize="large" />
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 500, color: '#2e7d32', fontSize: '0.9rem' }}>
                        Current Status
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                        {walkIns.some(w => w.status === 'in-progress') ? 'Busy' : 'Available'}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {/* Today's Appointments */}
            <Typography variant="h6" component="h3" gutterBottom sx={{ 
              fontWeight: 600, 
              color: '#3498db', 
              mt: 4,
              mb: 2,
              fontSize: { xs: '1.1rem', md: '1.3rem' }
            }}>
              Today's Scheduled Appointments
            </Typography>
            <TableContainer sx={{ 
              mb: 4,
              border: '1px solid #e9ecef',
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              '& .MuiTableCell-root': {
                py: 1.5,
                px: 2
              }
            }}>
              <Table size="small">
                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>Time</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Service</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {appointments.length > 0 ? (
                    appointments.map((appointment, index) => (
                      <TableRow 
                        key={appointment.id || appointment.firebaseKey || index}
                        sx={{ '&:nth-of-type(odd)': { bgcolor: '#fafafa' } }}
                      >
                        <TableCell>{appointment.time || 'No time'}</TableCell>
                        <TableCell>{appointment.service || 'No service'}</TableCell>
                        <TableCell>{getStatusChip(appointment.status || 'pending')}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center" sx={{ bgcolor: '#f5f5f5', py: 1.5, fontStyle: 'italic' }}>No scheduled appointments today</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Current Walk-Ins */}
            <Typography variant="h6" component="h3" gutterBottom sx={{ 
              fontWeight: 600, 
              color: '#3498db', 
              mt: 4,
              mb: 2,
              fontSize: { xs: '1.1rem', md: '1.3rem' }
            }}>
              Current Walk-In Queue
            </Typography>
            <TableContainer sx={{ 
              mb: 2,
              border: '1px solid #e9ecef',
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
              '& .MuiTableCell-root': {
                py: 1.5,
                px: 2
              }
            }}>
              <Table size="small">
                <TableHead sx={{ bgcolor: '#f8f9fa' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Service</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {walkIns.length > 0 ? (
                    walkIns.map((walkIn, index) => (
                      <TableRow 
                        key={walkIn.id || walkIn.firebaseKey || index}
                        sx={{ '&:nth-of-type(odd)': { bgcolor: '#fafafa' } }}
                      >
                        <TableCell>{walkIn.name}</TableCell>
                        <TableCell>{walkIn.service}</TableCell>
                        <TableCell>{getStatusChip(walkIn.status)}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center" sx={{ bgcolor: '#f5f5f5', py: 1.5, fontStyle: 'italic' }}>No walk-ins in queue</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>

        {/* Walk-in Request Form Section */}
        <Grid item xs={12} md={5}>
          <Paper elevation={3} className="appointment-form" sx={{ 
            p: { xs: 2, md: 3 }, 
            borderRadius: '10px !important',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1) !important',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.95) !important'
          }}>
            <Typography 
              variant="h4" 
              component="h1" 
              gutterBottom 
              align="center" 
              className="form-title"
              sx={{ 
                fontSize: { xs: '1.5rem', md: '2rem' },
                color: 'var(--primary-color) !important',
                fontWeight: '600 !important',
                marginBottom: '1rem !important',
                textAlign: 'center'
              }}
            >
              Submit Your Walk-In Request
            </Typography>
            <Typography 
              variant="body1" 
              gutterBottom 
              align="center" 
              className="form-subtitle"
              sx={{
                color: 'var(--text-color) !important',
                opacity: 0.8,
                marginBottom: '1.5rem !important',
                fontSize: '1rem'
              }}
            >
              Request a walk-in appointment with our professional barbers
            </Typography>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2.5} sx={{ mt: 0.5 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Full Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    variant="outlined"
                    size="medium"
                    InputProps={{
                      sx: { borderRadius: 1.5, fontSize: '1.1rem' }
                    }}
                    InputLabelProps={{
                      sx: { fontSize: '1.1rem' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    variant="outlined"
                    size="medium"
                    InputProps={{
                      sx: { borderRadius: 1.5, fontSize: '1.1rem' }
                    }}
                    InputLabelProps={{
                      sx: { fontSize: '1.1rem' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    label="Phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    variant="outlined"
                    size="medium"
                    InputProps={{
                      sx: { borderRadius: 1.5, fontSize: '1.1rem' }
                    }}
                    InputLabelProps={{
                      sx: { fontSize: '1.1rem' }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth required variant="outlined" size="medium">
                    <InputLabel sx={{ fontSize: '1.1rem' }}>Service</InputLabel>
                    <Select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      label="Service"
                      sx={{ borderRadius: 1.5, fontSize: '1.1rem' }}
                    >
                      {services.map((service) => (
                        <MenuItem key={service} value={service}>
                          {service}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Additional Notes"
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    multiline
                    rows={3}
                    variant="outlined"
                    size="medium"
                    InputProps={{
                      sx: { borderRadius: 1.5, fontSize: '1.1rem' }
                    }}
                    InputLabelProps={{
                      sx: { fontSize: '1.1rem' }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button 
                    type="submit" 
                    variant="contained"
                    color="primary"
                    size="large"
                    fullWidth
                    disabled={isSubmitting}
                    className="submit-button"
                    sx={{ 
                      mt: 1, 
                      py: 2,
                      fontWeight: 700,
                      whiteSpace: 'nowrap',
                      borderRadius: '8px',
                      boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
                      fontSize: '1.2rem'
                    }}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit Walk-In Request'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>
      </Grid>
        
      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default WalkIn;
